@import "../../packages/shared/scss";

$model-animation-buffer: $model-hover-animation-translate-space +
  p-px-to-rem(4px);

:host {
  display: block;
  inline-size: 100%;

  &.model-tile-level-l2 {
    @include model-max-width("l2");
  }

  &.model-tile-level-l3 {
    @include model-max-width("l3");
  }
}

.model-area-button.sc-phn-model-tile {
  // overrides negative margins from tile classes
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 0px;
  padding-inline-end: 0px;
  border: none;
}

.model-area-button {
  display: block;
  margin-block: 0;
  margin-inline: 0;
  padding-block: 0;
  padding-inline: 0;
  inline-size: 100%;

  @include pds-focus("none");
  @include pds-hover;

  background: transparent;
  border-radius: p-px-to-rem(12px);
  cursor: pointer;

  &:hover,
  &:focus,
  &:active {
    background-color: $pds-theme-light-background-base;

    img.model-image {
      @include model-hover-animation-transform();
    }
  }

  .model-content {
    padding-block: $pds-spacing-static-x-small;
    padding-inline: $pds-spacing-static-x-small;

    @include pds-media-query-min("s") {
      padding-block: $pds-spacing-static-medium;
      padding-inline: $pds-spacing-static-medium;
    }

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .model-image-container {
      position: relative;
      overflow: hidden;
      inline-size: 100%;

      display: block;
      box-sizing: border-box;
      margin-block-start: $pds-spacing-static-x-small;

      &--suv {
        padding-block-end: 34.58%; /* 240:83 ratio */
      }

      &--standard {
        padding-block-end: 29.375%; /* 160:47 ratio */
      }

      &--placeholder {
        // placeholders act like standard vehicles images for better positioning see car-body-types-drawer
        padding-block-end: 29.375%; /* 160:47 ratio (actual: /* 247:139 ratio */
        .model-image {
          margin-block-start: -40px !important;

          @include pds-media-query-min("s") {
            margin-block-start: -34px !important;
          }

          @include pds-media-query-min("m") {
            margin-block-start: -36px !important;
          }

          @include pds-media-query-min("l") {
            margin-block-start: -40px !important;
          }
        }
      }

      &-ratio-content {
        position: absolute;
        inset-block-start: 0;
        inset-inline-start: 0;
        block-size: 100%;
        overflow: hidden;

        display: flex;
        justify-content: center;
        align-items: center;

        padding-block: 0;
        padding-inline: 0;
        padding-inline-end: $model-animation-buffer;
        inline-size: calc(100% - ($model-animation-buffer));

        @include pds-media-query-min("s") {
          padding-block: 0;
          padding-inline: $pds-spacing-static-medium $model-animation-buffer;
          inline-size: calc(
            100% - ($model-animation-buffer + $pds-spacing-static-medium)
          );
        }
      }

      .model-image {
        position: relative;
        backface-visibility: hidden;
        object-fit: cover;
        inline-size: 100%;
        block-size: auto;
        @include model-hover-animation-transition();

        &:dir(rtl) {
          scale: -1 1;
        }
      }
    }

    .model-tags {
      display: block;
      margin-block-start: $pds-spacing-static-small;

      phn-model-tags {
        display: block;
        block-size: 30px;
      }
    }
  }
}
